// extracted by mini-css-extract-plugin
export default {"loyaltyEarlyAccessSaleBanner":"loyaltyEarlyAccessSaleBanner_xtc34"};